unit ImportMappingManager;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  smx.webcore.types;

type
  TImportMappingManagerForm = class(TBaseListForm)
    MappingFilePicker: TFilePicker;
    AddMappingDialog: TMessageDlg;
    DeleteMappingDialog: TMessageDlg;
    RefreshGridTimer: TTimer;
    CopyMappingDataset: TXDataWebDataSet;
    CopyMappingDatasetId: TIntegerField;
    CopyMappingDatasetName: TStringField;
    CopyMappingDatasetMapping: TStringField;
    CopyMappingDatasetHasTitles: TBooleanField;
    CopyMappingDatasetRecordStatus: TStringField;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetName: TStringField;
    MainDatasetMapping: TStringField;
    MainDatasetHasTitles: TBooleanField;
    MainDatasetRecordStatus: TStringField;
    MainDatasetHasTitlesText: TStringField;
    MainDatasetMappingLabelText: TStringField;
    MainDatasetImportReadyText: TStringField;
    MainDatasetDateAddedText: TStringField;
    procedure MainDatasetCalcFields(Dataset: TDataSet);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MainDatasetAfterPost(DataSet: TDataSet);
    procedure RefreshGridTimerTimer(Sender: TObject);
    procedure CopyMappingDatasetAfterOpen(Dataset: TDataSet);
    procedure CopyMappingDatasetAfterPost(DataSet: TDataSet);
    procedure CopyMappingDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure AddButtonClick(Sender: TObject);
    procedure MappingFilePickerChange(Sender: TObject);
  private
    FCopyInProgress: Boolean;
    FCopyName: string;
    FCopyMapping: string;
    FCopyHasTitles: Boolean;
    [async]
    procedure DeleteSelectedRecord(RecordId: Integer); async;
    [async]
    procedure CopySelectedRecord(RecordId: Integer); async;
    procedure SelectMappingTemplateFile;
    [async]
    procedure PromptAddMappingChoice; async;
    [async]
    procedure CreateMappingFromFile; async;
    [async]
    procedure OpenMappingEditor(const AMappingId: Integer; const AJSONFileData: string = ''; ADelimiter: Char = #0); async;
    [async]
    procedure OpenCopiedMapping(const ACopyId: Integer); async;
    [async]
    procedure EditMapping(const ARecordId: string); async;
    function GetUniqueCopyMappingName(const ASourceName: string): string;
    function ResolveCopyMappingId(Info: TResolveResults): Integer;
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    procedure LoadData; override;
    procedure SearchData(const Value: string); override;
    function GetEditFormClass: TFormClass; override;
    function CreateGridInFormCreate: Boolean; override;
    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;
    function RecordViewOption: TViewOption; override;
  protected procedure LoadDFMValues; override; end;

var
  ImportMappingManagerForm: TImportMappingManagerForm;

implementation

{$R *.dfm}

uses
  ImportMappings,
  SMX.Web.Layout.Utils,
  SMX.Web.Utils,
  XData.Dataset.Utils,
  XData.Web.Client,
  MainDataModule;

const
  SInvalidFileEncoding =
    'Your file is not encoded in a format that is recognised. Please contact the GiftAider team for advice';
  SUnsupportedFileType =
    'That file type is not supported. Please upload a CSV or Excel (.xlsx) file.';
  SAddMappingPrompt =
    'Select a file to use as a template, or start from scratch with the default six columns.';
  SNotDeletedFilter =
    '(RecordStatus eq null) or (RecordStatus ne ''Deleted'')';
  mrMappingFromFile = 100;
  mrMappingFromScratch = 101;

procedure TImportMappingManagerForm.AddButtonClick(Sender: TObject);
begin
  PromptAddMappingChoice;
end;

procedure TImportMappingManagerForm.SelectMappingTemplateFile;
begin
  MappingFilePicker.Files.Clear;
  asm
    var el = document.getElementById('MappingFilePicker');
    if (el) el.click();
  end;
end;

procedure TImportMappingManagerForm.PromptAddMappingChoice;
var
  lResult: TModalResult;
begin
  lResult := await(TModalResult, AddMappingDialog.ShowDialog(
    SAddMappingPrompt, mtInformation, []));
  if lResult = mrMappingFromFile then
    SelectMappingTemplateFile
  else if lResult = mrMappingFromScratch then
  begin
    PrepareMappingCreate;
    OpenMappingEditor(0);
  end;
end;

procedure TImportMappingManagerForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditMapping(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure CopyClick(Sender: TObject);
  begin
    CopySelectedRecord(StrToIntDef(ARecordId, 0));
  end;

var
  Span: THTMLSpan;
begin
  Span := THTMLSpan(TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'Edit'));
  TLayoutUtils.SetActionRecordId(Span, ARecordId);
  Span.OnClick := @EditClick;

  if ARecordId <> '' then
  begin
    Span := THTMLSpan(TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-copy', 'Duplicate'));
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @CopyClick;

    Span := THTMLSpan(TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete'));
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @DeleteClick;
  end;
end;

function TImportMappingManagerForm.CreateGridInFormCreate: Boolean;
begin
  Result := False;
end;

procedure TImportMappingManagerForm.CreateMappingFromFile;
var
  lFileName, lFile, JSONFileData: string;
  lRetval: TXDataClientResponse;
  lResult: TJSObject;
  lImportData: TJSObject;
  lDelimiter: Char;
begin
  if (not Assigned(MappingFilePicker.Files)) or (MappingFilePicker.Files.Count = 0) then
    Exit;

  if MappingFilePicker.Files.Count > 1 then
  begin
    DisplayMessage('Please select only one file.');
    MappingFilePicker.Files.Clear;
    Exit;
  end;

  ListWaitMessage.Show;
  try
    lFileName := MappingFilePicker.Files[0].Name;
    lFile := await(string, MappingFilePicker.Files[0].FileAsBase64);

    lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(
      'IGiftAiderService.ImportMappingUpload', [lFileName, lFile]));
    lResult := lRetval.ResultAsObject;
    JSONFileData := JS.ToString(lResult['value']);

    if JSONFileData = 'unrecoginsed-encoding' then
    begin
      DisplayMessage(SInvalidFileEncoding);
      Exit;
    end;

    if JSONFileData = 'unsupported-file-type' then
    begin
      DisplayMessage(SUnsupportedFileType);
      Exit;
    end;

    lDelimiter := ',';
    lImportData := TJSJSON.parseObject(JSONFileData);
    if assigned(lImportData) and assigned(lImportData['FieldDelimiter']) then
    begin
      if Length(JS.ToString(lImportData['FieldDelimiter'])) > 0 then
        lDelimiter := JS.ToString(lImportData['FieldDelimiter'])[1];
    end;

    OpenMappingEditor(0, JSONFileData, lDelimiter);
  finally
    ListWaitMessage.Hide;
    MappingFilePicker.Files.Clear;
  end;
end;

procedure TImportMappingManagerForm.DeleteSelectedRecord(RecordId: Integer);
var
  lMappingName: string;
  lResult: TModalResult;
begin
  if RecordId <= 0 then
    Exit;
  if not MainDataset.Locate(FIdField, RecordId, []) then
    Exit;

  lMappingName := MainDatasetName.AsString;
  lResult := await(TModalResult, DeleteMappingDialog.ShowDialog(
    Format('Delete mapping "%s"?', [lMappingName]),
    mtConfirmation, [mbYes, mbNo]));
  if lResult <> mrYes then
    Exit;

  if not MainDataset.Locate(FIdField, RecordId, []) then
    Exit;

  MainDataset.Edit;
  MainDatasetRecordStatus.AsString := 'Deleted';
  MainDataset.Post;
end;

procedure TImportMappingManagerForm.CopySelectedRecord(RecordId: Integer);
var
  lName, lMapping: string;
  lHasTitles: Boolean;
begin
  if not MainDataset.Locate(FIdField, RecordId, []) then
    Exit;

  lName := MainDatasetName.AsString;
  lMapping := MainDatasetMapping.AsString;
  lHasTitles := MainDatasetHasTitles.AsBoolean;

  FCopyInProgress := True;
  FCopyName := GetUniqueCopyMappingName(lName);
  FCopyMapping := lMapping;
  FCopyHasTitles := lHasTitles;

  ListWaitMessage.Show;
  try
    await(MainData.DataConnection.OpenAsync);
    if CopyMappingDataset.Active then
      CopyMappingDataset.Close;
    CopyMappingDataset.Load;
  except
    FCopyInProgress := False;
    ListWaitMessage.Hide;
    raise;
  end;
end;

procedure TImportMappingManagerForm.CopyMappingDatasetAfterOpen(Dataset: TDataSet);
begin
  if not FCopyInProgress then
    Exit;

  try
    CopyMappingDataset.Insert;
    CopyMappingDatasetName.AsString := FCopyName;
    CopyMappingDatasetMapping.AsString := FCopyMapping;
    CopyMappingDatasetHasTitles.AsBoolean := FCopyHasTitles;
    CopyMappingDatasetRecordStatus.AsString := 'Active';
    CopyMappingDataset.Post;
  except
    FCopyInProgress := False;
    ListWaitMessage.Hide;
    raise;
  end;
end;

procedure TImportMappingManagerForm.CopyMappingDatasetAfterPost(DataSet: TDataSet);
begin
  CopyMappingDataset.ApplyUpdates;
end;

procedure TImportMappingManagerForm.CopyMappingDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
var
  lIdx, lCopyId: Integer;
  lFailed: Boolean;
begin
  if not FCopyInProgress then
    Exit;

  lFailed := False;
  for lIdx := 0 to High(Info.Records) do
  begin
    if Info.Records[lIdx].ResolveStatus = rsResolveFailed then
    begin
      lFailed := True;
      Break;
    end;
  end;

  FCopyInProgress := False;
  ListWaitMessage.Hide;

  if lFailed then
  begin
    DisplayMessage('Could not create a copy of this mapping. Please try again.');
    Exit;
  end;

  { Server-generated Id is in ResolveResults, not always on the field yet. }
  TXDataDSUtils.UpdateAllIds(CopyMappingDataset, Info, 'Id');
  lCopyId := ResolveCopyMappingId(Info);

  { Do not reload MainDataset here — that races OpenMappingEditor.Locate.
    OpenMappingEditor refreshes the grid when the editor closes. }
  if lCopyId > 0 then
    OpenCopiedMapping(lCopyId)
  else
  begin
    if Assigned(FGridPlugin) then
      FGridPlugin.Load;
    DisplayMessage('Mapping copy was created, but it could not be opened automatically. Please open it from the list.');
  end;
end;

function TImportMappingManagerForm.ResolveCopyMappingId(Info: TResolveResults): Integer;
var
  lIdx: Integer;
  lInfoData: TJSObject;
begin
  Result := CopyMappingDatasetId.AsInteger;
  if Result > 0 then
    Exit;

  for lIdx := 0 to High(Info.Records) do
  begin
    if Info.Records[lIdx].ResolveStatus = rsResolveFailed then
      Continue;
    if not Assigned(Info.Records[lIdx].Data) then
      Continue;
    lInfoData := TJSObject(Info.Records[lIdx].Data);
    if not Assigned(lInfoData) then
      Continue;
    Result := StrToIntDef(JS.toString(lInfoData['Id']), 0);
    if Result > 0 then
      Exit;
  end;
end;

procedure TImportMappingManagerForm.OpenCopiedMapping(const ACopyId: Integer);
begin
  { Defer past ApplyUpdates so the modal loads outside the dataset event stack. }
  asm
    await new Promise(function(resolve) { setTimeout(resolve, 0); });
  end;

  PrepareMappingEdit(ACopyId, FCopyName, FCopyMapping, FCopyHasTitles);
  OpenMappingEditor(ACopyId);
end;

procedure TImportMappingManagerForm.MainDatasetAfterPost(DataSet: TDataSet);
begin
  inherited;
  MainDataset.ApplyUpdates;
end;

procedure TImportMappingManagerForm.EditMapping(const ARecordId: string);
begin
  if not MainDataset.Locate(FIdField, ARecordId, []) then
    Exit;

  OpenMappingEditor(MainDatasetId.AsInteger);
end;

function TImportMappingManagerForm.GetUniqueCopyMappingName(const ASourceName: string): string;
const
  SCopySuffix = ' - Copy';
begin
  Result := ASourceName;
  if Length(Result) + Length(SCopySuffix) > MainDatasetName.Size then
    Result := Copy(Result, 1, MainDatasetName.Size - Length(SCopySuffix));

  Result := Result + SCopySuffix;
  while MainDataset.Locate('Name', Result, []) do
  begin
    if Length(Result) + Length(SCopySuffix) > MainDatasetName.Size then
      Break;
    Result := Result + SCopySuffix;
  end;
end;

procedure TImportMappingManagerForm.MappingFilePickerChange(Sender: TObject);
begin
  CreateMappingFromFile;
end;

procedure TImportMappingManagerForm.OpenMappingEditor(const AMappingId: Integer; const AJSONFileData: string; ADelimiter: Char);
var
  AForm: TMappingsForm;
  lResult: TModalResult;
begin
  if AMappingId > 0 then
  begin
    { Prefer already-prepared copy/edit state — MainDataset may be mid-reload. }
    if not MappingEditIsPrepared(AMappingId) then
    begin
      if not (MainDataset.Active and MainDataset.Locate(FIdField, AMappingId, [])) then
        Exit;
      PrepareMappingEdit(
        MainDatasetId.AsInteger,
        MainDatasetName.AsString,
        MainDatasetMapping.AsString,
        MainDatasetHasTitles.AsBoolean);
    end;
  end
  else
    PrepareMappingCreate;

  AForm := TMappingsForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());

    if AMappingId > 0 then
      AForm.AfterCreated
    else
    begin
      if AJSONFileData <> '' then
      begin
        if ADelimiter <> #0 then
          AForm.Delimiter := ADelimiter
        else
          AForm.Delimiter := ',';
        AForm.JSONFileData := AJSONFileData;
      end;
      AForm.AfterCreated;
    end;

    lResult := await(TModalResult, AForm.Execute);
    if lResult = mrOK then
      ConsumeLastSavedMappingName;
  finally
    AForm.Free;
    AForm := nil;
  end;

  if Assigned(FGridPlugin) then
    FGridPlugin.Load;
end;

function TImportMappingManagerForm.GetEditFormClass: TFormClass;
begin
  Result := TMappingsForm;
end;

function TImportMappingManagerForm.InitSortCol: Integer;
begin
  Result := -1;
end;

function TImportMappingManagerForm.InitSortDirection: TSortDirection;
begin
  Result := sdAsc;
end;

procedure TImportMappingManagerForm.LoadData;
begin
  MainDataset.QueryString := '$orderby=Name asc';
  CreateGridPlugin;
  FGridPlugin.SetPreparedFilter(SNotDeletedFilter);
end;

procedure TImportMappingManagerForm.SearchData(const Value: string);
var
  lValue, lEscaped: string;
begin
  lValue := Trim(Value);
  if lValue = '' then
    FGridPlugin.SetPreparedFilter(SNotDeletedFilter)
  else
  begin
    // Search the real Name field (not calculated MappingLabelText). Combine with the
    // soft-delete filter because SetDefinedSearch would clear it.
    // Case-insensitive, same pattern as DonorList / AdvancedSearch.
    lEscaped := StringReplace(UpperCase(lValue), '''', '''''', [rfReplaceAll]);
    FGridPlugin.SetPreparedFilter(
      Format('(%s) and contains(upper(Name), ''%s'')', [SNotDeletedFilter, lEscaped]));
  end;
end;

procedure TImportMappingManagerForm.RefreshGridTimerTimer(Sender: TObject);
begin
  RefreshGridTimer.Enabled := False;
  if Assigned(FGridPlugin) then
    FGridPlugin.Load;
end;

procedure TImportMappingManagerForm.MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
var
  lIdx: Integer;
begin
  for lIdx := 0 to High(Info.Records) do
  begin
    if Info.Records[lIdx].ResolveStatus = rsResolveFailed then
    begin
      DisplayMessage('Could not update this mapping. Please try again.');
      Exit;
    end;
  end;

  RefreshGridTimer.Enabled := True;
end;

procedure TImportMappingManagerForm.MainDatasetCalcFields(Dataset: TDataSet);
begin
  if not MainDataset.Active then
    Exit;

  try
    MainDatasetMappingLabelText.Value := FormatImportMappingOptionLabel(
      MainDatasetName.AsString,
      MainDatasetMapping.AsString,
      MainDatasetLastUpdated.AsDateTime,
      MainDatasetDateAdded.AsDateTime);

    if MainDatasetHasTitles.AsBoolean then
      MainDatasetHasTitlesText.Value := 'Yes'
    else
      MainDatasetHasTitlesText.Value := 'No';

    if MappingJsonHasRequiredFields(MainDatasetMapping.AsString) then
      MainDatasetImportReadyText.Value := 'Yes'
    else
      MainDatasetImportReadyText.Value := 'No';

    if MainDatasetDateAdded.AsDateTime < 1 then
      MainDatasetDateAddedText.Value := ''
    else
      MainDatasetDateAddedText.Value := FormatDateTime(SYS_DATE_FORMAT, MainDatasetDateAdded.AsDateTime);
  except
    MainDatasetMappingLabelText.Value := MainDatasetName.AsString;
    MainDatasetHasTitlesText.Value := '';
    MainDatasetImportReadyText.Value := 'No';
    MainDatasetDateAddedText.Value := '';
  end;
end;

procedure TImportMappingManagerForm.PrepareForm;
begin
  FIdField := 'Id';
end;

function TImportMappingManagerForm.RecordViewOption: TViewOption;
begin
  Result := voCreateAndEdit;
end;

procedure TImportMappingManagerForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  UnLockControls(True);
end;

procedure TImportMappingManagerForm.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TImportMappingManagerForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MappingFilePicker := TFilePicker.Create('MappingFilePicker');
  AddMappingDialog := TMessageDlg.Create(Self);
  DeleteMappingDialog := TMessageDlg.Create(Self);
  RefreshGridTimer := TTimer.Create(Self);
  CopyMappingDataset := TXDataWebDataSet.Create(Self);
  CopyMappingDatasetId := TIntegerField.Create(Self);
  CopyMappingDatasetName := TStringField.Create(Self);
  CopyMappingDatasetMapping := TStringField.Create(Self);
  CopyMappingDatasetHasTitles := TBooleanField.Create(Self);
  CopyMappingDatasetRecordStatus := TStringField.Create(Self);
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetName := TStringField.Create(Self);
  MainDatasetMapping := TStringField.Create(Self);
  MainDatasetHasTitles := TBooleanField.Create(Self);
  MainDatasetRecordStatus := TStringField.Create(Self);
  MainDatasetHasTitlesText := TStringField.Create(Self);
  MainDatasetMappingLabelText := TStringField.Create(Self);
  MainDatasetImportReadyText := TStringField.Create(Self);
  MainDatasetDateAddedText := TStringField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  MappingFilePicker.BeforeLoadDFMValues;
  AddMappingDialog.BeforeLoadDFMValues;
  DeleteMappingDialog.BeforeLoadDFMValues;
  RefreshGridTimer.BeforeLoadDFMValues;
  CopyMappingDataset.BeforeLoadDFMValues;
  CopyMappingDatasetId.BeforeLoadDFMValues;
  CopyMappingDatasetName.BeforeLoadDFMValues;
  CopyMappingDatasetMapping.BeforeLoadDFMValues;
  CopyMappingDatasetHasTitles.BeforeLoadDFMValues;
  CopyMappingDatasetRecordStatus.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetName.BeforeLoadDFMValues;
  MainDatasetMapping.BeforeLoadDFMValues;
  MainDatasetHasTitles.BeforeLoadDFMValues;
  MainDatasetRecordStatus.BeforeLoadDFMValues;
  MainDatasetHasTitlesText.BeforeLoadDFMValues;
  MainDatasetMappingLabelText.BeforeLoadDFMValues;
  MainDatasetImportReadyText.BeforeLoadDFMValues;
  MainDatasetDateAddedText.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'MappingLabelText';
      Title := 'Mapping';
      Width := 320;
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ImportReadyText';
      Title := 'Ready for import';
      Width := 110;
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'HasTitlesText';
      Title := 'Has Titles';
      Width := 65;
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DateAddedText';
      Title := 'Date Added';
      Width := 100;
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 190;
    end;
    MappingFilePicker.SetParentComponent(Self);
    MappingFilePicker.Name := 'MappingFilePicker';
    MappingFilePicker.Left := 24;
    MappingFilePicker.Top := 16;
    MappingFilePicker.Width := 33;
    MappingFilePicker.Height := 22;
    SetEvent(MappingFilePicker, Self, 'OnChange', 'MappingFilePickerChange');
    AddMappingDialog.SetParentComponent(Self);
    AddMappingDialog.Name := 'AddMappingDialog';
    AddMappingDialog.Left := 120;
    AddMappingDialog.Top := 16;
    AddMappingDialog.Width := 24;
    AddMappingDialog.Height := 24;
    AddMappingDialog.Buttons := [];
    AddMappingDialog.CustomButtons.Clear;
    with AddMappingDialog.CustomButtons.Add do
    begin
      Caption := 'Select file';
      ElementClassName := 'btn btn-primary me-2';
    end;
    with AddMappingDialog.CustomButtons.Add do
    begin
      Caption := 'Start from scratch';
      ElementClassName := 'btn btn-outline-secondary';
    end;
    AddMappingDialog.ElementButtonClassName := 'btn';
    AddMappingDialog.ElementDialogClassName := 'PopUpForm';
    AddMappingDialog.ElementTitleClassName := 'text-body';
    AddMappingDialog.ElementContentClassName := 'text-body text-start';
    AddMappingDialog.Opacity := 0.200000000000000000;
    DeleteMappingDialog.SetParentComponent(Self);
    DeleteMappingDialog.Name := 'DeleteMappingDialog';
    DeleteMappingDialog.Left := 160;
    DeleteMappingDialog.Top := 16;
    DeleteMappingDialog.Width := 24;
    DeleteMappingDialog.Height := 24;
    DeleteMappingDialog.Buttons := [];
    DeleteMappingDialog.ElementButtonClassName := 'btn';
    DeleteMappingDialog.ElementDialogClassName := 'PopUpForm';
    DeleteMappingDialog.ElementTitleClassName := 'text-body';
    DeleteMappingDialog.ElementContentClassName := 'text-body text-start';
    DeleteMappingDialog.Opacity := 0.200000000000000000;
    RefreshGridTimer.SetParentComponent(Self);
    RefreshGridTimer.Name := 'RefreshGridTimer';
    RefreshGridTimer.Left := 200;
    RefreshGridTimer.Top := 16;
    SetEvent(RefreshGridTimer, Self, 'OnTimer', 'RefreshGridTimerTimer');
    CopyMappingDataset.SetParentComponent(Self);
    CopyMappingDataset.Name := 'CopyMappingDataset';
    CopyMappingDataset.AfterApplyUpdates := CopyMappingDatasetAfterApplyUpdates;
    CopyMappingDataset.AfterOpen := CopyMappingDatasetAfterOpen;
    CopyMappingDataset.AfterPost := CopyMappingDatasetAfterPost;
    CopyMappingDataset.Connection := MainData.DataConnection;
    CopyMappingDataset.EntitySetName := 'ImportMappings';
    CopyMappingDataset.Left := 200;
    CopyMappingDataset.Top := 16;
    CopyMappingDatasetId.SetParentComponent(CopyMappingDataset);
    CopyMappingDatasetId.Name := 'CopyMappingDatasetId';
    CopyMappingDatasetId.FieldName := 'Id';
    CopyMappingDatasetName.SetParentComponent(CopyMappingDataset);
    CopyMappingDatasetName.Name := 'CopyMappingDatasetName';
    CopyMappingDatasetName.FieldName := 'Name';
    CopyMappingDatasetName.Size := 255;
    CopyMappingDatasetMapping.SetParentComponent(CopyMappingDataset);
    CopyMappingDatasetMapping.Name := 'CopyMappingDatasetMapping';
    CopyMappingDatasetMapping.FieldName := 'Mapping';
    CopyMappingDatasetMapping.Size := 4096;
    CopyMappingDatasetHasTitles.SetParentComponent(CopyMappingDataset);
    CopyMappingDatasetHasTitles.Name := 'CopyMappingDatasetHasTitles';
    CopyMappingDatasetHasTitles.FieldName := 'HasTitles';
    CopyMappingDatasetRecordStatus.SetParentComponent(CopyMappingDataset);
    CopyMappingDatasetRecordStatus.Name := 'CopyMappingDatasetRecordStatus';
    CopyMappingDatasetRecordStatus.FieldName := 'RecordStatus';
    CopyMappingDatasetRecordStatus.Size := 10;
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    MainDataset.AfterPost := MainDatasetAfterPost;
    SetEvent(MainDataset, Self, 'OnCalcFields', 'MainDatasetCalcFields');
    MainDataset.EntitySetName := 'ImportMappings';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetName.SetParentComponent(MainDataset);
    MainDatasetName.Name := 'MainDatasetName';
    MainDatasetName.FieldName := 'Name';
    MainDatasetName.Size := 255;
    MainDatasetMapping.SetParentComponent(MainDataset);
    MainDatasetMapping.Name := 'MainDatasetMapping';
    MainDatasetMapping.FieldName := 'Mapping';
    MainDatasetMapping.Size := 4096;
    MainDatasetHasTitles.SetParentComponent(MainDataset);
    MainDatasetHasTitles.Name := 'MainDatasetHasTitles';
    MainDatasetHasTitles.FieldName := 'HasTitles';
    MainDatasetRecordStatus.SetParentComponent(MainDataset);
    MainDatasetRecordStatus.Name := 'MainDatasetRecordStatus';
    MainDatasetRecordStatus.FieldName := 'RecordStatus';
    MainDatasetRecordStatus.Size := 10;
    MainDatasetHasTitlesText.SetParentComponent(MainDataset);
    MainDatasetHasTitlesText.Name := 'MainDatasetHasTitlesText';
    MainDatasetHasTitlesText.FieldKind := fkCalculated;
    MainDatasetHasTitlesText.FieldName := 'HasTitlesText';
    MainDatasetHasTitlesText.Size := 3;
    MainDatasetHasTitlesText.Calculated := True;
    MainDatasetMappingLabelText.SetParentComponent(MainDataset);
    MainDatasetMappingLabelText.Name := 'MainDatasetMappingLabelText';
    MainDatasetMappingLabelText.FieldKind := fkCalculated;
    MainDatasetMappingLabelText.FieldName := 'MappingLabelText';
    MainDatasetMappingLabelText.Size := 320;
    MainDatasetMappingLabelText.Calculated := True;
    MainDatasetImportReadyText.SetParentComponent(MainDataset);
    MainDatasetImportReadyText.Name := 'MainDatasetImportReadyText';
    MainDatasetImportReadyText.FieldKind := fkCalculated;
    MainDatasetImportReadyText.FieldName := 'ImportReadyText';
    MainDatasetImportReadyText.Size := 3;
    MainDatasetImportReadyText.Calculated := True;
    MainDatasetDateAddedText.SetParentComponent(MainDataset);
    MainDatasetDateAddedText.Name := 'MainDatasetDateAddedText';
    MainDatasetDateAddedText.FieldKind := fkCalculated;
    MainDatasetDateAddedText.FieldName := 'DateAddedText';
    MainDatasetDateAddedText.Size := 16;
    MainDatasetDateAddedText.Calculated := True;
  finally
    DataTable.AfterLoadDFMValues;
    MappingFilePicker.AfterLoadDFMValues;
    AddMappingDialog.AfterLoadDFMValues;
    DeleteMappingDialog.AfterLoadDFMValues;
    RefreshGridTimer.AfterLoadDFMValues;
    CopyMappingDataset.AfterLoadDFMValues;
    CopyMappingDatasetId.AfterLoadDFMValues;
    CopyMappingDatasetName.AfterLoadDFMValues;
    CopyMappingDatasetMapping.AfterLoadDFMValues;
    CopyMappingDatasetHasTitles.AfterLoadDFMValues;
    CopyMappingDatasetRecordStatus.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetName.AfterLoadDFMValues;
    MainDatasetMapping.AfterLoadDFMValues;
    MainDatasetHasTitles.AfterLoadDFMValues;
    MainDatasetRecordStatus.AfterLoadDFMValues;
    MainDatasetHasTitlesText.AfterLoadDFMValues;
    MainDatasetMappingLabelText.AfterLoadDFMValues;
    MainDatasetImportReadyText.AfterLoadDFMValues;
    MainDatasetDateAddedText.AfterLoadDFMValues;
  end;
end;

end.
